enum ISourceType {
    Anthology = "Anthology",
    Article = "Article",
    Bookcontribution = "Bookcontribution",
    Monograph = "Monograph",
    Paper = "Paper",
    Website = "Website"
}

export default ISourceType;


// WEBPACK FOOTER //
// ./src/interfaces/ISourceType.ts